/**
 * 第五階段（花蓮市區包）：花蓮市區、東大門夜市、松園別館和吉安。
 * 標示「英文練習」的句子在所有語言中都刻意保留英文。
 */
import type { Messages } from './en';

export const zhTWHlcity: Pick<Messages, 'hlcity'> = {
  hlcity: {
    mapNames: { hlcity: '花蓮市區' },
    zones: {
      hcStation: '花蓮車站',
      hcCreative: '花蓮文化創意產業園區',
      hcPine: '松園別館',
      hcMeilun: '美崙溪',
      hcSnacks: '市區小吃街',
      hcIndigenous: '原住民一條街',
      hcMainland: '大陸各省一條街',
      hcDongdamen: '東大門夜市',
      hcHotel: '海景飯店',
      hcBike: '海濱自行車道',
      hcBeibin: '北濱公園',
      hcContainer: '貨櫃咖啡',
      hcQingxiu: '慶修院',
      hcPaddies: '吉安稻田',
      hcJian: '吉安',
      hlcity: '花蓮市區',
    },
    objects: {
      hc_shuttle: '台灣好行公車站',
      hc_mural: '阿美族壁畫',
      hc_shrine: '土地公廟',
      hc_marketMap: '夜市地圖',
      hc_dumpling: '水餃攤',
      hc_beefNoodle: '牛肉麵攤',
      hc_xlb: '小籠包攤',
      hc_sausage: '烤香腸攤',
      hc_bamboo: '竹筒飯攤',
      hc_crafts: '阿美族手工藝品',
      hc_icecream: '花生捲冰淇淋',
      hc_tea: '珍珠奶茶攤',
      hc_balloon: '射氣球',
      hc_creative: '文創園區告示牌',
      hc_pineGarden: '松園別館石碑',
      hc_riverMouth: '出海口觀景台',
      hc_bikePath: '自行車道指示牌',
      hc_seafront: '海邊望遠鏡',
      hc_container: '貨櫃咖啡菜單',
      hc_photo: '拍照點',
      hc_temple: '慶修院本堂',
      hc_buddha88: '八十八尊石佛',
      hc_paddy: '稻田告示牌',
      hc_store: '好鄰居便利商店',
    },
    npc: {
      hc_stationStaff: '車站站務員',
      hc_taxiDriver: '計程車司機',
      hc_shuttleGuide: '台灣好行導覽員',
      hc_dumplingGrandpa: '水餃爺爺',
      hc_sausageVendor: '香腸伯伯',
      hc_amisGrandma: '阿美族奶奶',
      hc_balloonVendor: '遊戲攤阿姨',
      hc_singer: '夜市歌手',
      hc_cyclist: '騎單車的人',
      hc_jogger: '慢跑的人',
      hc_barista: '咖啡師',
      hc_caretaker: '寺院管理員',
      hc_pineGuide: '松園導覽員',
      hc_farmer: '種稻的農夫',
    },
    items: {},

    closed: '攤位蓋著帆布。東大門夜市下午五點才開——晚上再來吧！',
    stampHint: '在東大門吃下第一口：護照上多了一個新印章！',
    look: '👀 只是看看',
    back: '↩️ 返回',

    // 用英文點餐（vendor、ok 和 bad 是英文練習）。
    food: {
      dumpling: { vendor: 'Pork dumplings, boiled fresh! Ten or twenty?', ok: 'Ten dumplings, please. With soy sauce.', bad: ['Dumplings. Hundred. Go.', 'I am a dumpling, please.'], done: '十顆多汁的水餃，剛從鍋裡撈起來。沾一沾、吹一吹、咬一口！', price: 40 },
      beefNoodle: { vendor: 'Beef noodle soup! Clear soup or red braised?', ok: 'Red braised, please. A small bowl.', bad: ['Noodle! Beef! Fast!', 'Cow soup for one cow.'], done: '軟嫩的牛肉、Q彈的麵條，還有濃郁的紅燒湯頭。這是爺爺跟他爸爸學的祖傳配方。', price: 60 },
      xlb: { vendor: 'Xiaolongbao! Soup inside — be careful, it’s hot!', ok: 'One basket, please. Thank you!', bad: ['Give me hot soup balls.', 'Basket. Now. Me.'], done: '先咬一個小洞，喝一口湯，再把小籠包吃掉。好好吃！', price: 50 },
      sausage: { vendor: 'Grilled pork sausage with garlic! Small or big?', ok: 'One small sausage, please.', bad: ['Sausage. Biggest. Free.', 'I want a sausage tree.'], done: '香腸用炭火烤，又香又甜又多汁——是原住民一條街最受歡迎的小吃！', price: 30 },
      bamboo: { vendor: 'Bamboo-tube rice! Sticky rice cooked inside bamboo.', ok: 'Could I have one, please? It smells great!', bad: ['Bamboo. Eat. Me.', 'One panda, please.'], done: '伯伯把竹筒剖開：糯米黏黏的，還有森林的香味。阿美族的家庭會在節慶時煮竹筒飯。', price: 45 },
      crafts: { vendor: 'Handmade bracelets! Glass beads in many colours.', ok: 'Could I have the red one, please? It’s beautiful.', bad: ['Bracelet. Cheap. Now.', 'Give me all the beads.'], done: '奶奶幫你把手環綁在手腕上，笑著說：「紅色代表力量和快樂。」', price: 20 },
      icecream: { vendor: 'Peanut ice-cream roll! With coriander or without?', ok: 'Without coriander, please. One roll.', bad: ['Ice cream. Wrap. Fast.', 'Coriander only, no ice cream.'], done: '薄薄的潤餅皮包著刨下來的花生糖粉和兩球冰淇淋。又脆又冰！', price: 35 },
      tea: { vendor: 'Bubble tea! Sugar level and ice level?', ok: 'Half sugar, less ice, please.', bad: ['Tea. Bubbles. Max.', 'All the sugar in the world.'], done: 'Q彈的珍珠配上香濃的奶茶。半糖剛剛好！', price: 30 },
      container: { vendor: 'Welcome to Container Coffee! What would you like?', ok: 'Can I have a small hot chocolate, please?', bad: ['Chocolate. Hot. Give.', 'I want the whole container.'], done: '一杯暖暖的熱可可，奶泡上畫了一朵小浪花。你一邊喝，一邊看著疊起來的貨櫃。', price: 30 },
      store: { vendor: 'Welcome! Hot tea eggs and baked sweet potatoes today.', ok: 'One tea egg, please. How much is it?', bad: ['Egg. Tea. Money no.', 'One store, please.'], done: '茶葉蛋用茶葉和香料滷過，咖啡色的蛋上有大理石般的花紋。台灣每家便利商店都有一鍋！', price: 12 },
    },

    // 景點。
    shuttle: '台灣好行公車在這裡停靠：有往太魯閣和七星潭的公車。',
    mural: '車站的壁畫畫著阿美族的圖紋：紅色代表力量，還有白色菱形，黃色代表太陽。阿美族是台灣人口最多的原住民族，很多族人住在花蓮一帶。',
    muralQ: 'What do the Amis celebrate every summer?',
    muralA: ['The harvest festival', 'A snow festival', 'Halloween'],
    muralRight: '答對了！豐年祭（Ilisin）：大家手牽手圍成一個大圓圈唱歌跳舞，感謝這一年的收穫。',
    muralWrong: '不太對喔。看看壁畫裡手牽手跳舞的人……',
    shrine: '一座小小的土地公廟，土地公會保佑這附近的街坊鄰居。店家早上會帶水果來拜拜、點香。',
    shrineEn: 'Please keep our street safe.', // English practice
    pray: '🙏 雙手合十',
    prayed: '你拜了三下。香的煙裊裊飄上天空。',
    marketMap: '東大門夜市：由四個老夜市合併成的超大夜市。有原住民一條街、大陸各省一條街、福町和自強的攤位，還有遊戲攤和現場音樂。每天晚上五點開到半夜十二點。',
    marketQ: 'When does the night market open?',
    marketA: ['At five p.m.', 'At five a.m.', 'At twelve noon'],
    marketRight: '對！下午五點燈一亮，烤肉的煙就飄滿整條街。',
    marketWrong: '嗯，再看一次地圖上的營業時間。',
    balloon: '用飛鏢射破氣球！五支飛鏢 10 枚金幣。',
    play: '🎯 玩一次（10 枚金幣）',
    balloonQ: 'How many balloons did you pop?',
    balloonRight: '數得好！阿姨送你一張小貼紙當獎品。',
    balloonWrong: '再數一次 💥！',
    nums: ['zero', 'one', 'two', 'three', 'four', 'five'],
    popped: (n: string) => `I popped ${n} balloons!`, // English practice
    creative: '這座園區以前是花蓮酒廠，大約一百年前的日治時期蓋的。現在老倉庫裡有藝術展覽、小店和音樂會。',
    creativeLook: '🏭 偷看一下倉庫裡面',
    creativeDone: '裡面有在地藝術家的畫作、一個小舞台，還有老木頭和很久以前米酒的味道。',
    creativeEn: 'This used to be a winery. Now it is an art park.', // English practice
    pine: '松園別館，1942 年：一棟白色兩層樓、有拱廊的日治時期建築，蓋在小山丘上，四周是一百多歲的琉球松。以前是軍事辦公處；現在是藝術和詩的空間，可以眺望美崙溪和太平洋。',
    pineQ: 'What kind of trees grow around the Pine Garden?',
    pineA: ['Pine trees', 'Palm trees', 'Apple trees'],
    pineRight: '對——是老琉球松，被海風吹得彎彎曲曲的。',
    pineWrong: '再看一次名字：「松」的英文是 “pine”。',
    riverMouth: '美崙溪在這裡流進太平洋。漁夫在沙洲上等魚上鉤，白鷺鷥在淺水裡抓魚。',
    riverEn: 'The river meets the sea.', // English practice
    lookAround: '🔭 用望遠鏡看看',
    lookedRiver: '你看到港口、出海口，還有遠方綠色的山一路延伸到藍色的大海裡。',
    bikePath: '海濱自行車道沿著海邊，從美崙溪一直通到市區南邊。日出的時候，大家在這裡騎車、慢跑、遛狗。',
    bikeQ: '騎腳踏車經過別人旁邊時，要說什麼呢？（英文練習）',
    bikeA: ['Excuse me, on your left!', 'Move, move!', 'Goodbye forever!'],
    bikeRight: '完美——有禮貌又清楚。記得按鈴喔！',
    bikeWrong: '這樣不太友善喔。再試一次！',
    seafront: '北濱公園面對著太平洋。天氣晴朗的早上，太陽會從海面升起，有時還能看到漁船開回港口。',
    seaEn: 'The sun rises over the Pacific Ocean.', // English practice
    listen: '🌊 聽聽海浪聲',
    listened: '噓……嘩……每一道浪打上來，小石頭就滾來滾去。',
    photo: '貨櫃咖啡是用 29 個舊貨櫃蓋成的，一個個疊起來、凸出去，像巨大的積木。貨櫃兩端的玻璃讓陽光照進來。',
    photoHow: '請路人幫你拍照。要怎麼說呢？（英文練習）',
    photoA: ['Could you take a photo of me, please?', 'Photo me. Now.', 'Take my camera away!'],
    photoRight: '喀嚓！背後是五顏六色的貨櫃，拍得超完美。',
    photoWrong: '嗯，試試更有禮貌的說法。',
    temple: '慶修院建於 1917 年，是當時住在吉安的日本移民農民蓋的。木造的本堂和石燈籠，讓它成為台灣保存得最好的日式寺院之一。',
    templeEn: 'This temple is more than one hundred years old.', // English practice
    wish: '🔔 敲鐘許願',
    wished: '咚……低沉的鐘聲傳遍整個庭院。你閉上眼睛，許了一個願望。',
    buddha: '小路兩旁坐著一尊尊石佛，每一尊代表日本四國島上有名的朝聖路線中的一座寺廟。走過全部的石佛，就像完成了一趟小小的朝聖之旅。',
    buddhaQ: 'How many stone Buddhas are there?',
    buddhaA: ['Eighty-eight', 'Eighteen', 'Eight hundred'],
    buddhaRight: '對，88 尊！小路每一邊各有四排。',
    buddhaWrong: '再數一次：每一邊有四排，每排十一尊……',
    paddy: '吉安的稻田引進清澈的山泉水。白鷺鷥在稻子之間走來走去，找青蛙和小魚吃。',
    paddyQ: 'What do farmers grow in these fields?',
    paddyA: ['Rice', 'Ice', 'Rocks'],
    paddyRight: '對！春天是綠色的，秋天變成金黃色。',
    paddyWrong: '仔細看看水裡的植物……',
    singer: '一位歌手抱著吉他，唱著台灣老歌和新的流行歌。攤位之間的人都跟著打拍子。',
    clap: '👏 跟著打拍子',
    clapped: '大家一起唱副歌。歌手向你揮手！',
    singerEn: 'Thank you, Hualien! One more song?', // English practice
    shuttleRide: '🚌 搭台灣好行',
    taxiEn: 'Could you take me to Dongdamen Night Market, please?', // English practice
    taxiQ: '要怎麼有禮貌地請計程車司機載你？（英文練習）',
    taxiA: ['Could you take me to Dongdamen Night Market, please?', 'Dongdamen. Drive.', 'Where is my taxi going?'],
    taxiRight: '“Sure! Seat belt on, please.”——下次你可以直接走路去：從這裡走只要十分鐘！',
    taxiWrong: '有點沒禮貌……試試有禮貌的問句。',

    // 人物：用玩家的語言說話，每個人再加一句英文（英文練習）。
    talk: {
      hc_stationStaff: {
        lines: ['歡迎來到花蓮！從臺北搭太魯閣號大約兩個小時。', '回家的火車從第一月台出發。別錯過晚上最後一班喔！', '車站的屋頂看起來像山，柱子上還有阿美族的圖紋。'],
        en: 'Welcome to Hualien! Enjoy your trip.', // English practice
      },
      hc_taxiDriver: {
        lines: ['要搭計程車嗎？花蓮很小——夜市十分鐘就到了。', '我在這裡開計程車開了二十年，每一家麵店我都知道！', '觀光客老是叫我載去太魯閣。搭台灣好行比較便宜啦！'],
        en: 'Where would you like to go?', // English practice
      },
      hc_shuttleGuide: {
        lines: ['綠色的台灣好行公車會開到太魯閣和七星潭。', '先把金幣準備好，坐右邊可以看海喔！', '最後一班車會在天黑前回來。'],
        en: 'Does this bus go to Taroko Gorge?', // English practice
      },
      hc_dumplingGrandpa: {
        lines: ['我爸爸是從山東來的。這些水餃是他的配方。', '這條巷子叫大陸各省一條街：有中國各地的美食。', '摺一摺、捏、捏、捏……我一個晚上要包五百顆水餃！'],
        en: 'How many would you like?', // English practice
      },
      hc_sausageVendor: {
        lines: ['歡迎來到原住民一條街！Nga’ay ho——這是阿美族語的「你好」。', '竹筒飯、烤香腸、小米糕……全都來自山裡和海邊。', '我們的祖父母教我們，食物要跟大家一起分享。'],
        en: 'Nga’ay ho! Hello and welcome!', // English practice
      },
      hc_amisGrandma: {
        lines: ['這些手環是我親手編的。每一種顏色都有意義。', '紅色是力量，白色是純潔，黃色是太陽。', '我們的豐年祭在夏天。整個部落都會一起跳舞！'],
        en: 'Did you make this by hand?', // English practice
      },
      hc_balloonVendor: {
        lines: ['五支飛鏢十枚金幣！射破三顆氣球就有獎品！', '瞄準中間，輕輕丟。', '小朋友常常比爸爸媽媽還厲害喔！'],
        en: 'Ready? Aim… throw!', // English practice
      },
      hc_singer: {
        lines: ['我每天晚上都在這裡唱歌。你會唱什麼歌嗎？', '這首是花蓮的老情歌。', '副歌的時候跟我一起拍手！'],
        en: 'Thank you, Hualien! One more song?', // English practice
      },
      hc_cyclist: {
        lines: ['我每天早上都騎海濱自行車道。每天的海都不一樣。', '從這裡可以一路騎到市區南邊。', '要戴安全帽，記得按鈴喔！'],
        en: 'On your left!', // English practice
      },
      hc_jogger: {
        lines: ['早安！河邊的步道最適合跑步了。', '我今天在出海口看到一隻蒼鷺。', '跑一跑、深呼吸、笑一個！'],
        en: 'Good morning! Lovely day, isn’t it?', // English practice
      },
      hc_barista: {
        lines: ['歡迎來到貨櫃咖啡！樓上的景色最棒。', '貨櫃凸出去，影子剛好可以遮住露台。', '我們的熱可可是小朋友的最愛。'],
        en: 'What size would you like: small, medium or large?', // English practice
      },
      hc_caretaker: {
        lines: ['我每天早上都會掃這條石頭小路，經過全部 88 尊石佛。', '日本農民蓋這座寺院的時候，這個村子叫做吉野村。', '在寺院裡要輕輕地走，到本堂前稍微鞠個躬。'],
        en: 'Please walk quietly in the temple.', // English practice
      },
      hc_pineGuide: {
        lines: ['這些琉球松已經一百多歲了。', '從陽台可以看到美崙溪流進大海。', '詩人會來這裡寫詩。我們來讀一首詩好嗎？'],
        en: 'The view from the top is beautiful.', // English practice
      },
      hc_farmer: {
        lines: ['吉安的稻米是用中央山脈的乾淨泉水種出來的。', '白鷺鷥是我的小幫手：牠們會吃掉害蟲！', '一年收成兩次：一次在夏天，一次在秋天。'],
        en: 'The rice is green now. In autumn it turns gold.', // English practice
      },
    },
  },
};
